<template>
    <div id="header" class="container-fuild isBottom" >
      <div >
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name, item)" style="cursor: pointer;">
            <router-link :to="item.path" v-if="item.isrouter" style="width: 100%;display: inline-block;padding:0">
              {{ item.name }}
            </router-link>
            <a v-else style="cursor: pointer;">
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "Header",
    data() {
      return {
        navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
        menuName: "官网首页",
        menuClass: "glyphicon glyphicon-menu-down",
        navList: [
          {
            name: "官网首页",
            path: "/Home",
            children: [],
            el: '.HomePage'
          },
          {
            name: "生产与研发",
            path: "/Production",
            children: [],
            el: '.Production1'
          },
          {
            name: "关于我们",
            path: "/About",
            children: [],
            el: '.Production'
          },
          {
            name: "旗下平台",
            path: "/Products",
            children: [],
            isrouter: true
          },
          {
            name: "产品中心",
            path: "/Production",
            children: [],
            isrouter: true
          },
          {
            name: "联系我们",
            path: "/About",
            children: [],
            el: '.Contact'
          },
        ],
        isBottom: false,
        isTop:true
      };
    },
    watch: {
      '$route.path': function (newVal) {
        this.isBottom = false
        if (newVal == '/Products') {
          this.$nextTick(() => {
            this.navClick(3, '旗下平台',)
          })
        } else if (newVal == '/Production') {
          this.$nextTick(() => {
            this.navClick(4, '产品中心',)
          })
  
        }
      }
    },
    created() {
      if (this.navIndex != '0') {
        this.menuName = this.navList[this.navIndex].name
      }
    },
    mounted() {
      
    },
    methods: {
      navClick(index, name = '', row) {
        document.documentElement.scrollTop = 0
        this.navIndex = index;
        sessionStorage.setItem('navIndex', index)
        this.menuName = name;
        if (row && row.el) {
          if (this.$route.path != '/Home') {
            this.$router.push('/Home')
          }
          this.$nextTick(() => {
            document.documentElement.scrollTop = document.querySelector(row.el) ? document.querySelector(row.el).offsetTop : 0
          })
        }
      },
      goHome() {
        this.$router.push('/Home')
        this.navClick(0, '官网首页')
      },
      menuClick() {
        if (this.menuClass == "glyphicon glyphicon-menu-down") {
          this.menuClass = "glyphicon glyphicon-menu-up";
        } else {
          this.menuClass = "glyphicon glyphicon-menu-down";
        }
      },
      changeLang(command) {
        this.$store.dispatch('changeLang', command)
        this.$nextTick(() => {
          this.setNav()
          this.menuName = this.navList[this.navIndex].name
        })
      },
      setNav() {
        Object.keys(this.$store.state.nav[this.$store.state.lang]).forEach(item => {
          this.navList[item].name = this.$store.state.nav[this.$store.state.lang][item]
        })
      }
    },
    computed: {
      lang() {
        return this.$store.state.langText
      },
      img() {
        return this.$store.state.img
      }
    }
  };
  </script>
  <style scoped >
  /* 顶部 */
  #header {
    background: var(--mainBG);
    transition: all ease 0.6s;
    position: absolute;
    border-radius: 40px;
    margin: 47px 58px;
    /* width: calc(100vw - 116px); */
    z-index: 999;
  }
  
  #header .header-top {
    height: 50px;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    background: #474747;
  }
  
  /* 顶部的图标 */
  #header .header-top span {
    margin: 0 8px;
  }
  
  /* 导航栏 */
  #header .header-nav {
    height: 80px;
  }
  
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 111px;
    height: 58px;
    width: 79px;
    cursor: pointer;
  }
  
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img:first-child {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 34px;
    height: 34px;
  }
  
  #header .header-nav .header-nav-logo img:last-child {
    position: absolute;
    bottom: 0;
    width: 79px;
    height: 27px;
  }
  
  /* 导航栏 导航容器 */
  #header .header-nav-fixed .header-nav-wrapper {
    line-height: 50px;
  }
  
  #header .header-nav .header-nav-wrapper {
    /* line-height: 80px; */
    /* padding-top: 25px; */
    display: flex;
    height: 80px;
    align-items: center;
    margin: 0;
    display: flex;
    width: calc(100vw - 112px - 134px - 484px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper>li {
    float: left;
    margin: 0 15px;
    position: relative;
    flex: 1;
    text-align: center;
  }
  
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper>li>a {
    color: var(--TextColor);
    font-size: 22px;
    padding: 15px 0 8px;
    position: relative;
  }
  
  /* 导航栏 每个导航下面的 a 链接的下划线 */
  #header .header-nav .header-nav-wrapper>li>a>i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #1e73be;
  }
  
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 12px;
    transition: transform ease 0.5s;
  }
  
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover {
    color: #1e73be;
    text-decoration: none;
  }
  
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }
  
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover span {
    transform: rotate(180deg);
  }
  
  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  #header .header-nav .header-nav-wrapper>li.active>a {
    color: var(--activeColor);
    text-decoration: none;
    /* font-size: 24px; */
    /* font-weight: 700; */
    /* border-bottom: 2px solid var(--activeColor); */
  }
  
  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav .header-nav-wrapper>li>dl {
    display: none;
    position: absolute;
    width: 168px;
    top: 80%;
    left: 0;
    z-index: 999999;
    box-shadow: 0 0 3px 1px #ccc;
    background: #fff;
  }
  
  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav .header-nav-wrapper>li>dl>dt {
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
  
  
  
  
  .lang-change {
    position: absolute;
    right: 200px;
    top: 30px;
    width: 60px;
    z-index: 2;
    cursor: pointer;
    font-size: 18px;
  }
  
  .lang-change .active-lang {
    color: var(--activeColor);
    font-weight: bold;
  }
  
  .search {
    position: absolute;
    right: 112px;
    top: 28px;
    width: 26px;
    height: 26px;
    z-index: 2;
    cursor: pointer;
  }
  
  .search img {
    width: 100%;
  }
  
  .three-horizontals {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 55%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  
  
  .el-icon--right {
    margin-left: 5px;
  }
  
  .el-dropdown {
    color: #333
  }
  
  .isBottom {
    bottom: 32px;
    background: transparent !important;
    left: 241px;
    padding: 0;
    margin: 102px 0 0 0 !important;
  }
  
  .isBottom>div>ul {
    display: flex;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  
  .isBottom>div>ul>li {
    margin-right: 85px;
  }
  
  .isBottom>div>ul>li a {
    color: #6B6B6B;
  }
  
  .isBottom>div>ul>li a:hover {
    color: #1e73be;
    text-decoration: none;
  }
  
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  .isBottom>div>ul>li a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }
  
  
  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  .isBottom>div>ul .active a {
    position: relative;
  
  }
  
  .isBottom>div>ul .active a::before {
    content: ' ';
    display: block;
    position: absolute;
    width: 100%;
    height: 9px;
    background: linear-gradient(90deg, #45AFFF 0%, #61FF53 100%);
    border-radius: 0px 0px 0px 0px;
    bottom: -12px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/footerRouter.vue